/* eslint-disable @typescript-eslint/naming-convention */
import { createAsyncThunk } from '@reduxjs/toolkit'

import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'
import { saveAs } from 'file-saver'
import {
  fetchConfigBankDataApi,
  downloadConfigBankTableApi,
  fetchConfigBankAlertApi,
  getDocFileUrlAPI,
  getOrderDaysFFAPI,
} from '../../services/configBank'

const sliceName = 'configBank'

export const fetchConfigBankData = createAsyncThunk(
  `${sliceName}/fetchConfigBankData`,
  async (
    { endpoint, query }: { endpoint: string; query: { [key: string]: string } },
    { rejectWithValue },
  ) => {
    try {
      const response = await fetchConfigBankDataApi(endpoint, query)
      return response.data
    } catch (e) {
      callErrorMsg(e)
      return rejectWithValue((e as Error).message)
    }
  },
)

export const fetchConfigBankAlert = createAsyncThunk(
  `${sliceName}/fetchConfigBankAlert`,
  async ({ endpoint }: { endpoint: string }, { rejectWithValue }) => {
    try {
      const response = await fetchConfigBankAlertApi(endpoint)
      return response.data
    } catch (e) {
      callErrorMsg(e)
      return rejectWithValue((e as Error).message)
    }
  },
)

export const downloadConfigBankTable = createAsyncThunk(
  `${sliceName}/downloadConfigBankTable`,
  async (
    { endpoint, isInvalidOnly }: { endpoint: string; isInvalidOnly: boolean },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await downloadConfigBankTableApi(endpoint, isInvalidOnly)

      if (data?.data?.queuing) {
        toastSuccess('File is being queued for download. It will send to your email shortly.')
      } else {
        const downloadResponse = await getDocFileUrlAPI(data?.data?.file_url, 'application/csv')
        saveAs(downloadResponse?.data, `rl_vendor_details.csv`)
      }
      return data
    } catch (e) {
      callErrorMsg(e)
      return rejectWithValue((e as Error).message)
    }
  },
)

export const fetchOrderDaysFF = createAsyncThunk(
  `${sliceName}/fetchOrderDaysFF`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getOrderDaysFFAPI()
      return response.data
    } catch (e) {
      callErrorMsg(e)
      return rejectWithValue((e as Error).message)
    }
  },
)
